/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState, useEffect } from "react";
import { withTranslation } from "react-i18next";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import { Image, Anchor } from "hesus-ui-kit";
import {
  FormBody,
  OptionsWrapper,
  FlexRow,
  SectionContainer,
  OuterWrapper,
  RowTitleText,
  WrapperStatus,
  ContactDetail,
  ButtonData,
  CompanyDetail,
  ActiveButton,
  InActiveButton,
  PendingButton,
  CommunicationDetail,
  EmailDetail,
  PhoneDetail,
  CommunicationOuterWrapper,
  PlatformNotExist,
  PlatformExist,
  EditorDescription,
  EditorDescriptionWrapper,
  EditorDescriptionTitle,
} from "./ContactView.styled";
import { avatarIcons, avatarIconsMr, avatarIconsMs } from "@utils/avatarInfo";

import LinkedEntityList from "./components/LinkedEntityList";
import emailIcon from "@icons/ic-email.svg";
import phoneIcon from "@icons/ic-phone.svg";
import mobilePhoneIcon from "@icons/ic-mobile-phone.svg";
import platformIcon from "@icons/ic-platform.svg";
import noPlatformIcon from "@icons/ic-platform-no.svg";

const ContactView = (props) => {
  const { t, contactInfo } = props;
  const courtseyText = { "": "", MISTER: "Mr", MISS: "Mrs" };
  const [avatarImage, setAvatarImage] = useState(avatarIcons[1]);
  const avatarNumber = Math.floor(Math.random() * 10);
 

  useEffect(() => {
    if (contactInfo.courtesy === "MISTER") {
      setAvatarImage(avatarIconsMr[avatarNumber] ?? avatarIcons[1]);
    } else if (contactInfo.courtesy === "MISS") {
      setAvatarImage(avatarIconsMs[avatarNumber] ?? avatarIcons[4]);
    } else {
      setAvatarImage(avatarIcons[avatarNumber] ?? avatarIcons[1]);
    }
  }, []);
  

  return (
    <FormBody>
      <OptionsWrapper>
        <FlexRow>
          <SectionContainer>
            <OuterWrapper>
              {avatarImage && (
                <Image
                  src={avatarImage}
                  alt="Avatar"
                  styles={{ height: "100px", width: "100px" }}
                />
              )}
              <ContactDetail>
                <RowTitleText>
                  {contactInfo.courtesy !== null &&
                    courtseyText[contactInfo.courtesy] + " "}
                  {contactInfo.firstName + " " + contactInfo.lastName}
                </RowTitleText>
                <CompanyDetail>
                  {contactInfo.job !== null && contactInfo.job + " "}
                  {contactInfo.company !== null &&
                    contactInfo.job !== null &&
                    t("GENERAL_AT") + " "}

                  {contactInfo.company !== null && (
                    // eslint-disable-next-line jsx-a11y/anchor-is-valid
                    <Link
                      to={`/company/view/${contactInfo.company.id}/general-info`}
                    >
                      {contactInfo.company.name}
                    </Link>
                  )}
                </CompanyDetail>
                <WrapperStatus>
                  {contactInfo.roles !== null &&
                    contactInfo.roles.map((role, index) => {
                      return (
                        <ButtonData key={index}>{`${t(
                          role.roleLabel
                        )}`}</ButtonData>
                      );
                    })}
                </WrapperStatus>
              </ContactDetail>
              <WrapperStatus>
                {contactInfo.status === 1 && (
                  <ActiveButton>{t("ACTIVE")}</ActiveButton>
                )}
                {contactInfo.status === 2 && (
                  <InActiveButton>{t("INACTIVE")}</InActiveButton>
                )}
                {contactInfo.status === null && (
                  <PendingButton>{t("PENDING")}</PendingButton>
                )}
              </WrapperStatus>
            </OuterWrapper>
            <CommunicationOuterWrapper>
              <CommunicationDetail>
                {contactInfo.email !== null && contactInfo?.email !== "" && (
                  <EmailDetail>
                    <Image
                      src={emailIcon}
                      alt={t("EMAIL")}
                      title={t("EMAIL")}
                      styles={{
                        width: "18px",
                        margin: "0 8px 0 8px",
                      }}
                    />
                    <Anchor url={`mailto:${contactInfo.email}`} target="_blank">
                      {contactInfo.email}
                    </Anchor>
                    <br></br>
                  </EmailDetail>
                )}
                <PhoneDetail>
                  {contactInfo.mobilePhone !== null &&
                    contactInfo?.mobilePhone !== "" && (
                      <>
                        <Image
                          src={mobilePhoneIcon}
                          alt={t("MOBILE")}
                          title={t("MOBILE")}
                          styles={{
                            width: "18px",
                            margin: "0 8px 0 8px",
                          }}
                        />
                        {contactInfo.mobilePhone}
                      </>
                    )}
                  {contactInfo.phone !== null && contactInfo?.phone !== "" && (
                    <>
                      <Image
                        src={phoneIcon}
                        alt={t("PHONE")}
                        title={t("PHONE")}
                        styles={{
                          width: "18px",
                          margin: "0 8px 0 8px",
                        }}
                      />
                      {contactInfo.phone}
                    </>
                  )}
                </PhoneDetail>
              </CommunicationDetail>
              <WrapperStatus>
                {!contactInfo?.isPlatfrom && (
                  <PlatformNotExist>
                    <Image
                      src={noPlatformIcon}
                      alt={t("PLATFORM")}
                      title={t("PLATFORM")}
                      styles={{
                        width: "18px",
                        margin: "0 8px 0 8px",
                      }}
                    />
                    {t("CONTACT_IS_USER")}
                  </PlatformNotExist>
                )}
                {contactInfo?.isPlatfrom && (
                  <PlatformExist>
                    <Image
                      src={platformIcon}
                      alt={t("PLATFORM")}
                      title={t("PLATFORM")}
                      styles={{
                        width: "18px",
                        margin: "0 8px 0 8px",
                      }}
                    />
                    {t("CONTACT_IS_USER")}
                  </PlatformExist>
                )}
              </WrapperStatus>
            </CommunicationOuterWrapper>
            {contactInfo.comment !== null && (
              <>
                <EditorDescriptionWrapper>
                  <EditorDescriptionTitle>
                    {t("CONTACT_COMPLEMENTARY_INFO")}
                  </EditorDescriptionTitle>
                </EditorDescriptionWrapper>
                <EditorDescriptionWrapper>
                  <EditorDescription>
                    <div
                      dangerouslySetInnerHTML={{
                        __html: contactInfo.comment,
                      }}
                    ></div>
                  </EditorDescription>
                </EditorDescriptionWrapper>
              </>
            )}
            {contactInfo.linkedEntities !== null &&
              contactInfo.linkedEntities.length > 0 && (
                <>
                  <EditorDescriptionWrapper>
                    <EditorDescriptionTitle>
                      {t("LINKED_ENTITIES")}
                    </EditorDescriptionTitle>
                  </EditorDescriptionWrapper>
                  <EditorDescriptionWrapper>
                    <LinkedEntityList enitites={contactInfo.linkedEntities} />
                  </EditorDescriptionWrapper>
                </>
              )}
          </SectionContainer>
        </FlexRow>
      </OptionsWrapper>
    </FormBody>
  );
};

ContactView.propTypes = {
  t: PropTypes.func.isRequired,
};

export default withTranslation()(ContactView);
